import React from 'react';
import { Box, Container, Typography, Grid, Link, Button } from '@mui/material';
import { styled } from '@mui/system';
import { HashLink as RouterLink } from 'react-router-hash-link';

// Wrapper stopki
const FooterWrapper = styled(Box)(({ theme }) => ({
  backgroundImage: 'url(/img/footerbg.png)',
  backgroundRepeat: 'no-repeat',
  backgroundSize: 'cover',
  paddingTop: '200px',
  paddingBottom: '20px',
  color: '#fff',
  '@media (max-width: 600px)': {
    paddingTop: '20px',
    backgroundImage: 'none',
    backgroundColor: theme.palette.primary.main,
  },
}));

const SectionFooter = () => (
  <>
    <FooterWrapper component="footer" id="footer">
      <Container maxWidth="xl">
        <Grid container spacing={4}>
          {/* Logo i adres */}
          <Grid item size={{ xs: 12, md: 2 }}>
            <Box component="img" src="/img/logofooter.svg" alt="Bimetria logo" />

          </Grid>

          <Grid item size={{ xs: 12, md: 2 }}>

          </Grid>


          {/* Menu */}
          <Grid
            item
            size={{ xs: 12, md: 3 }}
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: { xs: 'center', md: 'flex-start' }, // <-- tu
            }}
          >
      <Typography
  sx={{
    fontSize: '22px',
    fontWeight: 400,
    lineHeight: 1.5,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  }}
>
  <Link href="/#top" underline="none" sx={{ color: '#fff', mx: 1 }}>
    Home
  </Link>
  <Link href="/#about" underline="none" sx={{ color: '#fff', mx: 1 }}>
    O usłudze
  </Link>
  <Link href="/#package" underline="none" sx={{ color: '#fff', mx: 1 }}>
    Pakiety
  </Link>
  <Link href="/#section8" underline="none" sx={{ color: '#fff', mx: 1 }}>
    Kontakt
  </Link>
</Typography>
          </Grid>
          {/* Godziny otwarcia */}

          {/* Wypróbuj za darmo */}
          <Grid item xs={12} md={5}>
            <Box
              display="flex"
              alignItems="center"
              sx={{
                height: '100%',
                // na mobile: zawijanie, centrowanie i odstęp 20px
                flexWrap: { xs: 'wrap', md: 'nowrap' },
                justifyContent: { xs: 'center', md: 'flex-end' },
                gap: { xs: '20px', md: 0 },
              }}
            >
              <Typography sx={{ fontSize: '24px', fontWeight: 'bold', mr: { xs: 0, md: 2 } }}>
                Oszczędzaj czas i pieniądze
              </Typography>
              <Button
                component="a"
                href="https://app.bimetria.com"
                target="_blank"
                variant="contained"
                sx={{
                  backgroundColor: 'turquoise.main',
                  color: '#fff',
                  textTransform: 'none',
                  fontWeight: 500,
                  fontSize: { xs: '16px', md: '18px' },
                  px: { xs: 3, md: 4 },
                  py: { xs: 1.5, md: 2 },
                }}
              >
                Aplikacja Bimetria
              </Button>
            </Box>
          </Grid>

        </Grid>

        {/* Linia */}
        <Box sx={{ borderTop: '2px solid', borderColor: 'turquoise.main', mt: 4, width: '70%', mx: 'auto' }} />

        {/* Polityka i dostępność */}
        <Box sx={{ display: 'flex', justifyContent: 'flex-start', mt: 2, gap: 2 }}>
          <Link
            component={RouterLink}
            to="/polityka-prywatnosci#top"
            underline="none"
            sx={{ color: '#fff', fontSize: '12px' }}
          >
            Polityka prywatności
          </Link>
         
        </Box>
      </Container>
    </FooterWrapper>

    {/* Logotypy partnerów pod stopką */}
    <Box component="section" sx={{ py: 4 }}>
      <Container maxWidth="xl">
        <Grid container justifyContent="center">
          <Grid item size={{ xs: 12, md: 6 }}  id="logo-eu">
            <Box
              component="img"
              src="/img/eulogos.png"
              id="logo-eu2"
              alt="Partner logos"
              sx={{ display: 'block', mx: 'auto', width: '100%', maxWidth: '80%' }}
            />
          </Grid>
        </Grid>
      </Container>
    </Box>
  </>
);

export default SectionFooter;
